import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogTrackingService {
  private jwt = "&jwt="
  // private revenueForecast = environment.misreport + "employee/api/jwtV2/common/overallStats?filterBy="
  private token = ''

  constructor(private http: HttpClient) { }
  // getRevenueForecastOverAllStats(filterBy: any) {
  //   const headers = { 'Authorization': `${this.token}` };
  //   return this.http.get(this.revenueForecast + filterBy, { headers });
  // }

  getLogtracke() {
    const headers = { 'Authorization': `${this.token}` };
    return this.http.get(environment.logTrack + 'employee/api/jwtV2/logTrackList', { headers });
  }
  getfilter() {
    const headers = { 'Authorization': `${this.token}` };
    return this.http.get(environment.logTrack + 'employee/api/jwtV2/logtrack/filterKeys', { headers });
  }

  getFilterKey(filterKey: any) {
    const headers = { 'Authorization': `${this.token}` };
    return this.http.get(environment.logTrack + 'employee/api/jwtV2/logtrack/filterKeyValues?filterBy=' + filterKey, { headers });
  }

  postFilterLogSearch(payload: any) {
    const headers = { 'Authorization': `${this.token}` };
    return this.http.post(environment.logTrack + 'employee/api/jwtV2/logtrack/filterLogSearch', payload, { headers })
  }

}
